import { createMemoStyles } from '@wds/utils';
var useStyles = createMemoStyles({
  navSection: {
    display: 'flex',
    alignItems: 'center'
  }
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map